export default {
  actions: {
    apply: 'Apply',
    officialDocumentDownload: 'Get official document'
  },
  archive: {
    confirmAction: 'Archive',
    confirmDescription: 'Archive the procedure package for "{{targetName}}". It will be hidden from this list.',
    confirmTitle: 'Archive this package?',
    succeeded: 'Procedure package archived.'
  },
  archivedViewTitleSuffix: 'Archived',
  breadcrumbArchives: 'Archive',
  breadcrumbLaborCore: 'Labor core',
  bulkOperation: {
    active: {
      apply: 'Bulk apply',
      dataSync: 'Bulk data sync',
      officialDocumentDownload: 'Bulk official document download'
    },
    applyDialog: {
      cancel: 'Cancel',
      confirm: 'Submit',
      description: 'The selected targets will be submitted together. Cancellations after submission must be done individually.',
      detailsCount: '{{count}}',
      detailsTitle: 'Application targets',
      documentColumn: 'Document',
      targetColumn: 'Target',
      title: 'Submit bulk e-filings'
    },
    clearSelection: 'Clear selection',
    execute: {
      apply: 'Bulk apply',
      dataSync: 'Sync data',
      officialDocumentDownload: 'Get official documents'
    },
    executeSucceeded: {
      apply: 'Submitted {{count}} application(s).',
      dataSync: 'Synced {{count}} application(s).'
    },
    govProfileConflict: 'Selected rows use different e-filing profiles. Select rows that share the same profile.',
    govProfileMissingOnRows: 'Some selected rows do not have an e-filing profile configured.',
    govProfileRequired: 'Select an e-filing profile.',
    menuLabel: 'Bulk actions',
    options: {
      apply: 'Apply',
      dataSync: 'Sync data',
      officialDocumentDownload: 'Get official documents'
    },
    selectedCount: '{{count}} selected'
  },
  columns: {
    action: 'Action',
    arriveId: 'Arrive ID',
    category: 'Category',
    categoryPlaceholder: '—',
    documentName: 'Document',
    dueDate: 'Due date',
    lastSyncedAt: 'Last synced',
    status: 'Status',
    submittedAt: 'Submitted at',
    targetPerson: 'Person'
  },
  displayStatus: {
    amendFailed: 'Send failed (correction)',
    amending: 'Sending correction',
    completed: 'Completed',
    correctionPending: 'Correction pending',
    correctionPendingPartialCorrection: 'Correction pending (partial correction)',
    correctionPendingResubmission: 'Correction pending (resubmission)',
    inProgress: 'In progress',
    notApplied: 'Not applied',
    returned: 'Returned',
    returnedPartialCorrection: 'Returned (partial correction)',
    returnedResubmission: 'Returned (resubmission)',
    submitFailed: 'Send failed (new/re-apply)',
    submitting: 'Submitting',
    syncFailed: 'Sync failed',
    syncing: 'Syncing',
    withdrawFailed: 'Send failed (withdrawal)',
    withdrawInProgress: 'Withdrawal in progress',
    withdrawing: 'Withdrawing',
    withdrawn: 'Withdrawn'
  },
  drawer: {
    close: 'Close',
    collapseFromFullScreen: 'Exit full screen',
    completed: {
      alertMessage: 'The procedure has been completed',
      arriveIdLabel: 'Arrive ID',
      download: 'Download',
      downloadFailed: 'Failed to download the official document.',
      submittedAtLabel: 'Submitted at'
    },
    correctionPending: {
      alertMessage: 'Correction instructions from the government',
      attachmentDownloadFailed: 'Failed to download the attachment.',
      attachmentsLabel: 'Attachments',
      contentLabel: 'Details',
      deadlineLabel: 'Correction deadline',
      issueDateLabel: 'Issued at',
      submitCorrection: 'Submit correction'
    },
    editLink: 'Edit',
    expandToFullScreen: 'Show full screen',
    failed: {
      alertMessage: 'Failed to submit',
      errorContentWithValue: 'Error details: {{content}}',
      occurredAtWithValue: 'Occurred at: {{datetime}}',
      resubmit: 'Resubmit'
    },
    govProfile: {
      defaultSuffix: 'Default',
      emptyHint: 'Complete electronic certificate registration and e-Gov linkage in e-Gov application info settings.',
      label: 'e-Gov application info',
      placeholder: 'Select application info',
      settingsLink: 'Open e-Gov application info settings'
    },
    inProgress: {
      arriveIdLabel: 'Arrive ID',
      govReviewMessage: 'Under review by the government',
      lastSyncedLabel: 'Last synced',
      lastSyncedWithRelative: '{{datetime}} ({{relative}})',
      statusSync: 'Sync status',
      statusSyncProcessing: 'Syncing…',
      submittedAtLabel: 'Submitted at',
      withdrawApplication: 'Withdraw application'
    },
    inputLoading: 'Loading form…',
    inputSectionTitle: 'Input summary',
    notAppliedDescription: 'Review the details, then submit to e-Gov using the Apply button.',
    processing: {
      amending: 'Sending correction to e-Gov…',
      submitting: 'Sending application to e-Gov…',
      syncing: 'Syncing status with e-Gov…',
      withdrawInProgress: 'Sending withdrawal request to e-Gov…'
    },
    progressSteps: {
      ariaLabel: 'Application progress',
      complete: 'Complete',
      receive: 'Received',
      review: 'Review',
      send: 'Submit'
    },
    returned: {
      alertMessage: 'The application was returned',
      arriveIdLabel: 'Arrive ID',
      lastSyncedLabel: 'Last synced',
      reapply: 'Re-apply',
      reapplyNote: 'Resubmissions are treated as new applications and a new arrive ID will be issued.',
      reasonLabel: 'Return reason',
      returnedAtLabel: 'Returned at',
      submittedAtLabel: 'Submitted at'
    },
    save: 'Save',
    stepNotFound: 'Step not found for this row.',
    submitAction: {
      partialCorrection: 'Submit partial correction',
      resubmission: 'Resubmit'
    },
    submitDialog: {
      cancel: 'Cancel',
      documentLabel: 'Document',
      send: 'Send',
      targetLabel: 'Person',
      title: 'Send e-Gov application'
    },
    targetLabel: 'Person',
    title: 'Application details',
    unsupportedStatus: 'Details for this status are not available yet.'
  },
  dueDateRelative: {
    overdue: 'Overdue'
  },
  officialDocumentDownloadFailed: 'Failed to download the official document.',
  officialDocumentDownloadNoFiles: 'No downloadable official documents.',
  officialDocumentDownloadSucceeded: 'Downloaded {{count}} official document(s).',
  pageTitle: 'Administrative application procedures',
  searchPlaceholder: 'Search by person name or document name...',
  statusFilter: 'Status',
  summaryRow: {
    toggleSteps: 'Toggle nested procedures'
  },
  viewByMember: 'By member',
  viewByProcedure: 'By procedure'
};